import React from 'react';
import { translatePayment } from 'components/EnrollmentV2/util/translation';

const ReviewPayment = ({ state }) => {
    return (
        <div className="text-start">
            <p>
                {translatePayment(
                    state?.enrollment.page4.sub3['premiumPaymentOption']
                )}
            </p>
        </div>
    );
};

export default ReviewPayment;
